/**
 * @desc 进入订单信息编辑页面
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
  /** 订单id */
  orderId?: number
}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/mall/order/getDetail',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
